<template>
  <div class="btn-fixed-wrap">

    <vs-button
      :class="'dark-mode-button'"
      type="filled"
      icon-pack="feather"
      :icon="icon"
      @click="changeTheme()"
    >
      <div v-if="this.$store.state.theme === 'dark'"><span class="dark-mode-label">다크모드 </span><span class="highlight">ON</span></div>
      <div v-else><span class="dark-mode-label">다크모드 </span>OFF</div>
    </vs-button>

  </div>
</template>

<script>
export default {
  name: 'Global.DarkMode',
  computed: {
    icon () {
      const theme = this.$store.state.theme
      if (theme === 'dark') {
        return 'icon-moon'
      } else {
        return 'icon-moon'
      }
    }
  },
  methods: {
    changeTheme () {

      const mode = (this.$store.state.theme === 'dark') ? 'light' : 'dark'
      this.$store.dispatch('updateTheme', mode)
      localStorage.setItem('theme', mode)

    }
  }
}
</script>


<style lang="scss">
.btn-fixed-wrap {
  position: fixed;
  right: 115px;
  bottom: 5px;
  z-index: 99999;
}
.dark-mode-button {
  box-shadow: none !important;
  background-color: #414141 !important;
  border-radius: 20px;
  font-weight: bold;
}

.dark-mode-button .highlight {
  color: #ec813e;
}

@media only screen and (max-width: 960px) {
  .dark-mode-label {
    display: none;
  }
}
</style>
